import ilComponent from './TypeSelect'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

